
import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faBook,
  faCog,
} from '@fortawesome/free-solid-svg-icons';

import { useAuth } from '../../../../AuthContext';
import { redirectToLogin } from '../../../../utils/authRedirect';

import './SidebarMenuDropdown.css';
import { clearCourseStorage } from '../../../../utils/courseAccess';

const apiUrl = process.env.REACT_APP_API_URL;

const SidebarMenuDropdown = ({
  visible,
  position,
  onMenuSelect,
  selectedMenu,
  onMouseEnter,
  onMouseLeave,
  onClose,
}) => {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  const handleLogout = async () => {
    onClose?.();

    try {
      await fetch(`${apiUrl}/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      localStorage.removeItem('manuallyLoggedOut');
      clearCourseStorage();
      setUser(null);
      redirectToLogin();
    } catch (err) {
      console.warn('Logout failed:', err);
    }
  };

  if (!visible || !position || position.width <= 0) {
    return null;
  }

  const handleNavigate = (path) => {
    onClose?.();
    navigate(path);
  };

  return createPortal(
    <div
      className="sidebar-dropdown"
      style={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        width: position.width,
        zIndex: 99999,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      role="menu"
      aria-label="Mai multe"
    >
      <ul className="sidebar-dropdown-list">
        <li
          className={`sidebar-dropdown-item${
            selectedMenu === 'CoursesInPlace' ? ' active' : ''
          }`}
          role="menuitem"
          tabIndex={0}
          onClick={() => onMenuSelect?.('CoursesInPlace')}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onMenuSelect?.('CoursesInPlace');
            }
          }}
        >
          <span className="sidebar-dropdown-icon">
            <FontAwesomeIcon icon={faBook} />
          </span>
          <span>Cursuri</span>
        </li>

        <hr className="sidebar-dropdown-divider" />

        <li
          className={`sidebar-dropdown-item${
            selectedMenu === 'Setari' ? ' active' : ''
          }`}
          role="menuitem"
          tabIndex={0}
          onClick={() => onMenuSelect?.('Setari')}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              onMenuSelect?.('Setari');
            }
          }}
        >
          <span className="sidebar-dropdown-icon">
            <FontAwesomeIcon icon={faCog} />
          </span>
          <span>Setari</span>
        </li>

        <li
          className="sidebar-dropdown-item"
          role="menuitem"
          tabIndex={0}
          onClick={() => handleNavigate('/ajutor')}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleNavigate('/ajutor');
            }
          }}
        >
          <span>Ajutor</span>
        </li>

        <li
          className="sidebar-dropdown-item"
          role="menuitem"
          tabIndex={0}
          onClick={handleLogout}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              handleLogout();
            }
          }}
        >
          <span>Deconectare</span>
        </li>
      </ul>
    </div>,
    document.body
  );
};

export default SidebarMenuDropdown;
